module.exports = __webpack_public_path__ + "img/client14.4b6df087.svg";